import type { GTMEventData } from '@openeducation/pp-rn-shared-types';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

// The AppLovin events do not go through the dataLayer: pp-api-gateway sends
// them to the AppLovin Conversion API.
export function useGoogleTagManager() {
  const pushEvent = (eventData: GTMEventData) => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventData);
    }
  };

  return { pushEvent };
}
